const BASE_URL = 'https://docs.confluera.com/'
const DOCUMENTATION_URL = 'confluera-product-documentation/-MEOcNwk4wneFYN8mlLQ/v/v3.2/'
const RELEASE_NOTES_URL = 'release-notes/-MEOvA8wpFb_ut_ctPl0/confluera-3.2'
export default {
  methods: {
    loadDocumentation (name) {
      let page
      switch (name) {
        case 'page-home':
          page = ''
          break
        case 'page-dashboard':
          page = 'infrastructure-monitoring/anatomy-of-dashboard'
          break
        case 'dashboard-observation-funnel':
          page = 'infrastructure-monitoring/anatomy-of-dashboard/observation-funnel'
          break
        case 'dashboard-behavior-analysis':
          page = 'infrastructure-monitoring/anatomy-of-dashboard/detections'
          break
        case 'dashboard-activity-dial':
          page = 'infrastructure-monitoring/anatomy-of-dashboard/activity-dial'
          break
        case 'dashboard-assets':
          page = 'infrastructure-monitoring/anatomy-of-dashboard/asset-summary'
          break
        case 'dashboard-threat-progressions':
          page = 'infrastructure-monitoring/anatomy-of-dashboard/progressions'
          break
        case 'dashboard-insights':
          page = 'infrastructure-monitoring/insights'
          break
        case 'page-progressions':
          page = 'infrastructure-monitoring/managing-threat-progressions/view-threat-progressions'
          break
        case 'page-detections':
          page = 'infrastructure-monitoring/analyzing-detections'
          break
        case 'page-privileged-activity-trails':
          page = 'infrastructure-monitoring/insights/privileged-activities'
          break
        case 'page-activities':
          page = 'infrastructure-monitoring/insights/privileged-activities'
          break
        case 'page-insights':
          page = 'infrastructure-monitoring/insights/security-kpis'
          break
        case 'page-hosts':
          page = 'infrastructure-monitoring/monitoring-your-assets/vms'
          break
        case 'page-containers':
          page = 'infrastructure-monitoring/monitoring-your-assets/containers'
          break
        case 'page-container-images':
          page = 'infrastructure-monitoring/monitoring-your-assets/4.5.3.-container-images'
          break
        case 'page-threat-hunting':
          page = 'infrastructure-monitoring/threat-hunting'
          break
        case 'page-anomalies':
          page = 'infrastructure-monitoring/inspecting-anomalies'
          break
        case 'page-anomalies-rules':
          page = 'infrastructure-monitoring/inspecting-anomalies#anomaly-rules'
          break
        case 'page-rules':
          page = 'policies/rules'
          break
        case 'page-integration':
          page = 'setup/launchpad'
          break
        case 'page-cloud':
          page = 'setup/launchpad/connect-your-cloud'
          break
        case 'page-cloud-aws':
          page = 'setup/launchpad/connect-your-cloud/aws'
          break
        case 'page-cloud-gcp':
          page = 'setup/launchpad/connect-your-cloud/google-cloud'
          break
        case 'page-cloud-azure':
          page = 'setup/launchpad/connect-your-cloud/microsoft-azure'
          break
        case 'page-partner-signals-snyk':
          page = 'setup/launchpad/integrate-partner-signals/snyk'
          break
        case 'page-partner-signals-palo-alto-networks':
          page = 'setup/launchpad/integrate-partner-signals/palo-alto-networks'
          break
        case 'page-partner-signals-trend-micro':
          page = 'setup/launchpad/integrate-partner-signals/trend-micro'
          break
        case 'page-partner-signals-aws-elastic-load-balancing':
          page = 'setup/launchpad/integrate-partner-signals/aws-elastic-load-balancing'
          break
        case 'page-partner-signals-amazon-guard-duty':
          page = 'setup/launchpad/integrate-partner-signals/amazon-guard-duty'
          break
        case 'page-partner-signals-vmware-carbon-black':
          page = 'setup/launchpad/integrate-partner-signals/vmware-carbon-black'
          break
        case 'page-partner-signals-amazon-rds':
          page = 'setup/launchpad/integrate-partner-signals/amazon-rds'
          break
        case 'page-partner-signals-devo':
          page = 'setup/launchpad/integrate-partner-signals/devo'
          break
        case 'page-partner-signals-aws-cloudtrail':
          page = 'setup/launchpad/integrate-partner-signals/aws-cloudtrail'
          break
        case 'page-partner-signals-wef':
          page = 'setup/agent-installation/7.2.4.-windows-event-forwarding'
          break
        case 'page-signals':
          page = 'setup/launchpad/integrate-partner-signals'
          break
        case 'page-allowlist':
          page = 'policies/allow-list'
          break
        case 'page-users':
          page = 'settings/user-settings'
          break
        case 'page-network-restrictions':
          page = 'remediations/network-restrictions'
          break
        case 'page-quarantine-files':
          page = 'remediations/quarantine-files'
          break
        case 'page-slack-preference':
          page = 'setup/launchpad/set-up-slack-notifications'
          break
        case 'page-cloud-jira':
          page = 'setup/launchpad/7.1.6.-integrate-jira'
          break
        case 'page-settings':
          page = 'settings'
          break
        case 'page-notifications':
          page = 'notifications'
          break
        case 'page-installation-guide':
          page = 'setup/agent-installation'
          break
        case 'page-release-notes':
          window.open(BASE_URL + RELEASE_NOTES_URL)
          return
        default:
          return
      }
      window.open(BASE_URL + DOCUMENTATION_URL + page)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/loadDocumentationMixin.js